import React, { useState } from "react";
import dangerimage from "../../images/Danger Triangle.png";
import Openeye from "../../images/openeye.png";
import Closedeye from "../../images/closeeye.png";
import { useSelector } from "react-redux";
const Inputbox = ({ type, id, value, title, handleChange, error, placeholder }) => {
    const [showPassword, setShowPassword] = useState(false);
    const currentcountry = useSelector((state) => state.globalslice.currentcountry);

    const isPassword = type === "password";
    const actualInputType = isPassword && showPassword ? "text" : type;

    return (
        <div className="inputbox-margin">
            {title && <div className="inputbox-title">{title}</div>}

            <div className="inputbox-field" style={{ position: "relative" }}>
                {id === "mobile" && (
                    <span style={{ width: "100px", paddingRight: "10px" }}>
                        <input
                            className="form-control phonecountrycode"
                            type="text"
                            value={currentcountry.country_code}
                            disabled
                        />
                    </span>
                )}

                <input
                    type={actualInputType}
                    id={id}
                    name={id}
                    value={value}
                    onChange={handleChange}
                    placeholder={placeholder}
                    className={`forminputbox ${error ? "danderborder" : ""}`}
                />

                {isPassword && (
                    <div
                        className="inputboxeye"
                        onClick={() => setShowPassword(!showPassword)}
                        style={{
                           
                            transform: "translateY(-50%)",
                            cursor: "pointer",
                        }}
                    >
                        <img src={showPassword ? Closedeye : Openeye} alt="toggle visibility" />
                    </div>
                )}
            </div>

            {error && (
                <div style={{ color: "red" }}>
                    <img src={dangerimage} alt="error" />
                    <span className="incooretinput ps-2">{error}</span>
                </div>
            )}
        </div>
    );
};

export default Inputbox;
